<template>
    <div class="tags">
        <div v-if="tags.length">
            <el-tag
                v-for="(item,i) in tags"
                :key="i"
                effect="dark"
                v-if="Array.isArray(item.value) && item.value.length"
            >{{item.label}}{{ item.value[0] }}  <span v-if="item.value.length>1 && item.key !== 'date'"> <span>...</span> {{item.value.length}}个</span></el-tag>
        </div>

        <span v-else>请选择</span>
    </div>
</template>
<script>
import _ from 'lodash';
export default {
    props: {
        params: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            tags: [],
            labels: {
                order_ids: '订单号：',
                codes: '充值码：',
                gift_ids: '礼包ID：',
                player_ids: '领码PID：',
                date: '兑换时间：' ,
                order_type: '订单类型：',
                exchange_status: '兑换状态：'
            }
        }
    },
    watch: {
        params: {
            handler() {
                this.tags = [];
                let keys = Object.keys(this.params);
                if(Array.isArray(keys) && keys.length) {
                    keys.forEach(item => {
                        let vals = '';
                        if(this.params[item] &&  item !== 'player_type' && item !== 'date_type') {
                            let str = '';
                            if(typeof this.params[item] === 'string') {
                                str = this.params[item].replace(/\s+|[\r\n]/g, ',').replace(/，/g, ',');
                            }

                            vals = str.split(',').map(item => {
                                if(!_.isEmpty(item)) {
                                    return item;
                                }
                            }).filter(item => item);

                        }
                        if( item !== 'player_type') {
                            if(item === 'player_ids') {
                                let player_type = this.params.player_type === 1? '领码PID：' : '兑换PID：';
                                this.labels[item] = player_type;
                            }
                            if(item === 'date') {
                                let date = this.params.date_type === 1? '兑换时间：' : '领码时间：';
                                this.labels[item] = date;
                                vals = [this.params.date.join(' - ')];
                            }
                            this.tags.push({
                                label: this.labels[item],
                                value: vals,
                                key: item
                            })
                        }

                    })
                }
            },
            deep: true,
            immediate: true
        }
    }
}
</script>
<style scoped>
.tags >>> .el-tag--dark {
    margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// website/subComponents/simpleSearchData.vue